// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodRecipeId } from './FoodRecipe';
import { foodBenchmarkId } from './FoodBenchmark';
import { foodSensoryRoundId } from './FoodSensoryRound';
import { brewBatchId } from './BrewBatch';
import { z } from 'zod';
export const foodSensorySessionSampleId = (z.number());
export const foodSensorySessionSample = z.object({
    id: foodSensorySessionSampleId,
    recipe_id: foodRecipeId.nullable(),
    benchmark_id: foodBenchmarkId.nullable(),
    blinding_code: z.number(),
    is_reference: z.boolean(),
    display_order: z.number(),
    created_at: z.date().nullable(),
    round_id: foodSensoryRoundId,
    brew_batch_id: brewBatchId.nullable(),
    label: z.string().nullable(),
    portion_g: z.string().nullable(),
    farmless_share: z.string().nullable(),
});
export const foodSensorySessionSampleInitializer = z.object({
    id: foodSensorySessionSampleId.optional(),
    recipe_id: foodRecipeId.optional().nullable(),
    benchmark_id: foodBenchmarkId.optional().nullable(),
    blinding_code: z.number(),
    is_reference: z.boolean().optional(),
    display_order: z.number().optional(),
    created_at: z.date().optional().nullable(),
    round_id: foodSensoryRoundId,
    brew_batch_id: brewBatchId.optional().nullable(),
    label: z.string().optional().nullable(),
    portion_g: z.string().optional().nullable(),
    farmless_share: z.string().optional().nullable(),
});
export const foodSensorySessionSampleMutator = z.object({
    id: foodSensorySessionSampleId.optional(),
    recipe_id: foodRecipeId.optional().nullable(),
    benchmark_id: foodBenchmarkId.optional().nullable(),
    blinding_code: z.number().optional(),
    is_reference: z.boolean().optional(),
    display_order: z.number().optional(),
    created_at: z.date().optional().nullable(),
    round_id: foodSensoryRoundId.optional(),
    brew_batch_id: brewBatchId.optional().nullable(),
    label: z.string().optional().nullable(),
    portion_g: z.string().optional().nullable(),
    farmless_share: z.string().optional().nullable(),
});
//# sourceMappingURL=FoodSensorySessionSample.js.map